import React from 'react'
import Browse from '../component/Browse'
const Home = () => {
  return (
    <div className=''>
        
        <Browse path="home"/>
    </div>
  )
}

export default Home